import {INTERACTION_ID} from './symbols';
import createInteractionId from './createInteractionId';

export default function applyInteractionId(meta) {
	if (!meta[INTERACTION_ID]) meta[INTERACTION_ID] = createInteractionId(); // eslint-disable-line no-param-reassign

	return meta;
}
